import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiDivider from '@material-ui/core/Divider';

const Divider = ({
  variant,
  light,
  orientation,
  ...otherProps
}) => {
  // Components props
  let dividerProps = { variant, light, orientation };
  if (orientation === 'vertical') {
    dividerProps = {
      ...dividerProps,
      flexItem: true,
    };
  }

  return (
    <MuiDivider {...dividerProps} {...otherProps} />
  );
};

Divider.propTypes = {
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle']),
  light: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
};

Divider.defaultProps = {
  variant: 'fullWidth',
  light: false,
  orientation: 'horizontal',
};

export default React.memo(Divider);



// WEBPACK FOOTER //
// ./components/core/Divider.js